<app-dialog-container
  [title]="'subtaskComments' | translate"
  [isValid]="true"
  (confirmButtonHandler)="close()"
  [cancelButtonText]="'close' | translate"
  [showConfirmButton]="false"
>
  <app-comments
    [privilege]="data.privilege"
    [entityId]="data.entityId"
    [entityType]="data.entityType"
    [canAddComment]="data.canAddComment"
    [isInPopup]="true"
    [adminPrivilege]="data.adminPrivilege"
    [showDeleteButton]="data.showDeleteButton"
  ></app-comments>
</app-dialog-container>
